import React, { Context } from 'react';

import { RouteInfo } from '../../../../../shared/models/countryConfig';

export const RoutesContext: Context<RouteInfo[]> = React.createContext<RouteInfo[]>([]);
